export enum FinancialLogMutationType {
    unpaid = 'unpaid',
}
